import { Component, OnInit } from "@angular/core";
import { ErrorRouter } from "../../services/error-router";

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found-page.component.html',
    standalone: true
})
export class NotFoundComponent implements OnInit {

  constructor(private errorRouter: ErrorRouter) { }

  ngOnInit() {
    this.errorRouter.navigateToNotFound();
  }
}